<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="_campuses">

          <template slot="header" vs-justify="flex-end">
            <router-link :to="{name: 'master-campus-add'}" >
                <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('MasterCampus', 'create', 'b')"></vs-button>
            </router-link>
          </template>

          <template slot="thead">
            <vs-th sort-key="projectName">{{ $t("sections.master.dataForm.project") }}</vs-th>
            <vs-th sort-key="nameTh" >{{ $t("sections.master.dataForm.nameTh") }}</vs-th>
            <vs-th sort-key="nameEn">{{ $t("sections.master.dataForm.nameEn") }}</vs-th>
            <vs-th sort-key="status">{{ $t("sections.master.dataForm.status") }}</vs-th>
            <vs-th sort-key="default" class="w-1/12">{{ $t("sections.master.dataForm.default") }}</vs-th>
            <vs-th sort-key="#" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="index" v-for="(row, index) in data">
              <vs-td :data="row.projectName">
                {{ row.projectName }}
              </vs-td>
              <vs-td :data="row.nameTh">
                {{ row.nameTh }}
              </vs-td>
              <vs-td :data="row.nameEn">
                {{ row.nameEn }}
              </vs-td>
              <vs-td :data="row.status">
                <vs-chip :color="getStatusColor(row.status)" class="product-order-status">{{ row.status }}</vs-chip>
              </vs-td>
              <vs-td :data="row.isChoose">
                <vs-switch color="success" v-model="isChoose" :vs-value="row.id" icon-pack="feather" vs-icon="icon-check" />
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <router-link :to="{ name: 'master-campus-edit', params: {id: row.id } }" >
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('MasterCampus', 'edit', 'b')"></vs-button>
                  </router-link>
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="pms ('MasterCampus', 'delete', 'b')" @click="del(row.id);" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  async created () {
    const vm = this
    const { getCampuses } = vm
    await getCampuses()
    vm.pms ('MasterCampus', 'visible', 'r')
    const obj = vm.campuses.find(res => res.isChoose === true)
    vm.isChoose = ( obj ? [obj.id] : [])
    vm.tableName = 'campus'
  },
  computed: {
    ...mapMasterFields(['campuses', 'status']),
    _campuses () {
      return this.campuses.map(res => {
        return {
          ...res,
          isChoose: this.isChoose.includes(res.id)
        }
      })
    }
  },
  methods: {
    ...mapMasterActions(['getCampuses', 'deleteCampus']),
    async del (id) {
      const vm = this;
      const { deleteCampus } = vm;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteCampus({
            form: {
              id
            },
            vm
          });
        }
      })
    },
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
